import { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";

import api from "api/api";

// import Mui components
// import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
// import mui icons
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";

import { IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";

//import components
import ConsumerFilter from "../../common/ConsumerFilter";
import ProductInfo from "../../common/ProductInfo";
// utils
import SortFinalData from "../../../utils/SortFinalData";
// import GetMacroCategoryOrder from "../../../utils/GetMacroCategoryOrder";

import WeightToggleIcon from "../../../assets/icons/weightToggle.png";
import ColumnVisibility from "components/common/ColumnVisibility";

// redux
import { useSelector, useDispatch } from "react-redux";
import { loadProductOrderState } from "store/features/productsInfoSlice";
import HeaderSampleSize from "components/common/analysisModule/HeaderSampleSize";
import DragRenderTable from "components/common/analysisModule/DragRenderTable";
import SkewTabs from "components/common/analysisModule/SkewTabs";
import AnalysisTableBottomLabel from "components/common/analysisModule/AnalysisTableBottomLabel";
import ClaimsTerritoryFilter from "components/common/ClaimsTerritoryFilter";
import OverlappingScales from "components/common/analysisModule/boxAnalysis/OverlappingScales";
import ComparisonLegend from "../../common/TTest/ComparisonLegend";

import {
    getRecallAndITM,
    getProductScoreSumObject,
    getProductScoreWithNaAndRowSpan,
    getScoreByVariable,
    getProductColumnClassName,
    getViewKeys,
    getOralCareProductCodeTableHeader,
    getSelectedOption,
    getOverallCalculationResult,
    highlightText,
    getFormattedScoreOrNA,
    gapRow,
    getCustomRound,
    // getDataView,
    // getSortedDataMapping,
    // getAlphabeticalMacroCategories,
} from "../../../utils/analysisTable/analysisUtils";

import { getTestResultByVariable, getColorsAndLetter } from "../../../utils/analysisTable/tTestutils";
import { showNotification } from "store/features/notificationSlice";
import { loadFragranceAssociationOpenParentListState, loadActiveTabState } from "store/features/analysisResultsSlice";

import TableCellWithInnerSeparator from "components/common/analysisModule/TableCellWithInnerSeparator";
import TableCellWithOuterSeparator from "components/common/analysisModule/TableCellWithOuterSeparator";

function AnalysisTableFragranceAssociation({ productsSecondaryData = [], handleFilterSubmit = () => { }, analysisLevelData = {}, tTest = {}, settings = {},onRenderComplete = () => {} }) {
    const dispatch = useDispatch();
    // overallFragrance, fragranceAssociationMappings
    const { isITMDataShown = false, tableConfig, moduleName, boxAnalysisTypeSelection = [], boxAnalysisSelection = {}, analysisTypeValue, mappings, claimsTerritoryTags = [], claimsTerritorySelectedTags = [], overallFragrance, fragranceAssociationMappings } = analysisLevelData;
    const { tTestLegends, tTestFaLegends, isFisher, tTestResult, testLabel, testLabel2 } = tTest;
    const { activeTab, setActiveTab } = settings;
    const { stickyColumns = [] } = tableConfig;
    const isConsumerFilterLoadingStoreData = useSelector((state) => state.consumerFilterStore.isLoading);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);

    const overallToggle = useSelector((state) => state.analysisResultsStore.overallToggle);
    // const overallFragranceToggle = useSelector((state) => state.analysisResultsStore.overallFragranceToggle);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const productColumnVisibility = useSelector((state) => state.productsInfoStore.productsVisibility);
    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    // tTest
    const testAnalysisType = useSelector((state) => state.tTestStore.testAnalysisType);

    // dataview
    const overallAnalysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.overallAnalysisTypeValue);

    const hiddenProductsCount = Object.values(productColumnVisibility || {}).filter((datum) => datum === true)?.length || 0;

    const [productDetailsDialogueOpen, setProductDetailsDialogueOpen] = useState(false);
    // const likertScaleData = useSelector((state) => state.analysisResultsStore.likertScaleData);
    const productsTestCodeMapData = useSelector((state) => state.studyDataStore.productTestCodeMap);
    const isPercentage = useSelector((state) => state.analysisResultsStore.percentageToggle);
    const overallFragranceToggle = useSelector((state) => state.analysisResultsStore.overallFragranceToggle);
    const openParentList = useSelector((state) => state.analysisResultsStore.fragranceAssociationOpenParentList);

    // column drag and drop variables
    const [draggableColumns, setDraggableColumns] = useState(productsSecondaryData);
    const [draggedColumnIndex, setDraggedColumnIndex] = useState(null);
    const [draggedColumnDiamension, setDraggedColumnDiamension] = useState({ width: null, height: null });
    const [targetColumnIndex, setTargetColumnIndex] = useState(null);

    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [hasActuallyMoved, setHasActuallyMoved] = useState(false);

    const tableRef = useRef(null);
    const tbodyRef = useRef(null);
    const draggedElementRef = useRef(null);
    const initialMousePos = useRef(null);

    const [actionStandardKpis, setActionStandardKpis] = useState([]);
    const [actionStandardData, setActionStandardData] = useState([]);
    const removedKpiStoreState = useSelector((state) => state.analysisKpiStore[`${moduleName}RemovedKpiList`]);

    const [totalSampleSize, setTotalSampleSize] = useState(0);
    const [totalVisibleProducts, setTotalVisibleProducts] = useState(0);

    let noOfProducts = productsSecondaryData.length;
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    // const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    // const customOrderMacroCategory = GetMacroCategoryOrder(productCategoryData?.label?.toLowerCase(), moduleName);

    const [tableHeadSpan, setTableHeadSpan] = useState(1);
    const [box, setBox] = useState(false);

    const [dataViewKey, setDataViewKey] = useState(""); //ORDER [top:top_weight:mean:weight_mean, bottom:bottom_weight]
    const [tableDataMapping, setTableDataMapping] = useState([]);

    // input search
    const [searchValue, setSearchValue] = useState("");
    const [selectedProductInfo, setSelectedProductInfo] = useState({});
    const significanceToggle = useSelector((state) => state.analysisResultsStore.significanceToggle);
    const [skewTabsOverallFragranceMapping, setSkewTabsOverallFragranceMapping] = useState([]);

    const [openRows, setOpenRows] = useState({});

    useEffect(() => {
        onRenderComplete();
    }, [productsSecondaryData, onRenderComplete]);

    useEffect(() => {
        let tempRows = {}
        openParentList.forEach((ele) => {
            tempRows[ele] = true;
        });
        setOpenRows(tempRows)
    }, [openParentList])

    useEffect(() => {
        let tabs;
        let order;
        if (isUnileverFragranceHouse) {
            const excludedCategories = ["Primary", "Secondary"];
            tabs = mappings?.find((ele) => !excludedCategories.includes(ele.macroCategory));
            order = ["Colour most suitable for smelled fragrance", "Frag assosciated to colour spectrum on the screen", "Colour1 which assosciate more to frag", "Colour2 which assosciate more to frag", "Colour3 which assosciate more to frag", "Emoji best describes frag", "Describe emotions", "Smelling frag which emotional grouping will it fit", "Frag fit category", "Descriptors"];
        } else {
            tabs = mappings?.find((ele) => ele.macroCategory === "");
            order = ["Fragrance - Colour Association", "Fragrance Descriptor (Emotive)", "Fragrance-Brand Association", "Primary Fragrances Nodes & Fragrance Descriptors"];
        }
        let tempTabs = tabs?.displayLabels?.map((datum) => {
            const obj = {
                macroCategory: datum?.displayLabel,
                displayLabels: [datum],
            };

            return obj;
        }) || [];
        const tabsPrimary = mappings?.find((ele) => ele.macroCategory === "Primary");
        tempTabs.push({
            macroCategory: isUnileverFragranceHouse ? "Descriptors" : "Primary Fragrances Nodes & Fragrance Descriptors",
            displayLabels: tabsPrimary?.displayLabels,
        });

        tempTabs.sort((a, b) => {
            return order.indexOf(a.macroCategory) - order.indexOf(b.macroCategory);
        });
        setSkewTabsOverallFragranceMapping(tempTabs);
    }, [mappings]);

    useEffect(() => {
        let sampleTotal = 0;
        let visibleProducts = 0;
        draggableColumns.forEach((datum) => {
            const classNameKey = `checked--${datum.title.split(" ").join("_")}__${datum.coreDataId}`;
            if (!productColumnVisibility?.[classNameKey]) {
                sampleTotal += datum.sampleSize;
                visibleProducts += 1;
            }
        });
        setTotalSampleSize(sampleTotal);
        setTotalVisibleProducts(visibleProducts);
    }, [draggableColumns, productColumnVisibility]);

    useEffect(() => {
        const sortedData = skewTabsOverallFragranceMapping.filter((each) => each.macroCategory === activeTab);

        if (activeTab !== "Primary Fragrances Nodes & Fragrance Descriptors" || activeTab !== "Descriptors") {
            const backendVariable = sortedData.flatMap((item) => item.displayLabels).find((item) => item.displayLabel === activeTab)?.backendVariable;
            dispatch(loadActiveTabState(backendVariable));
        } else {
            dispatch(loadActiveTabState(""));
        }

        setTableDataMapping((prev) => {
            const isEqual = JSON.stringify(prev) === JSON.stringify(sortedData);
            return isEqual ? prev : sortedData;
        });
    }, [skewTabsOverallFragranceMapping, activeTab]);

    useEffect(() => {
        // const _dataViewKey = getDataView(analysisTypeValue, weightToggle, boxAnalysisTypeSelection);
        const { value } = analysisTypeValue;
        setBox(value === "box_analysis");
        setDataViewKey("mean");
    }, [analysisTypeValue, boxAnalysisTypeSelection, weightToggle]);

    useEffect(() => {
        const { value } = analysisTypeValue;
        setBox(value === "box_analysis");

        if (value === "box_analysis") {
            setTableHeadSpan(isITMDataShown ? boxAnalysisTypeSelection.length * 2 : boxAnalysisTypeSelection.length);
        } else if (value !== "box_analysis") {
            setTableHeadSpan(isITMDataShown ? 2 : 1);
        }
    }, [analysisTypeValue, isITMDataShown, boxAnalysisTypeSelection]);

    useEffect(() => {
        const sorted = selectedStudy
            .map((datum) => {
                const pro = Array.from(datum.products)
                    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
                    .map((ele) => {
                        return {
                            productCode: ele,
                            coreDataId: datum.id,
                            isCompetitor: false,
                        };
                    });
                const ulPro = Array.from(datum.competitor_products)
                    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
                    .map((ele) => {
                        return {
                            productCode: ele,
                            coreDataId: datum.id,
                            isCompetitor: true,
                        };
                    });
                return [...pro, ...ulPro];
            })
            .flat();

        dispatch(loadProductOrderState(sorted));
    }, [selectedStudy, dispatch]);

    useEffect(() => {
        setDraggableColumns(SortFinalData(productsSecondaryData, productsOrder));
    }, [productsSecondaryData, productsOrder]);

    const addBorders = useCallback(() => {
        // Check if the tbody element is available
        if (tbodyRef.current) {
            // Get all <tr> (table row) elements within the tbody
            const rows = Array.from(tbodyRef.current.querySelectorAll("tr.score-row"));
            let currentGroupLastRowIndex = 0;
            rows.forEach((row, index) => {
                const tds = row.querySelectorAll("td");
                const firstTd = row.querySelector("td");
                tds.forEach((td, i) => {
                    // clear all border styles
                    td.style.borderTop = "";
                    td.style.borderBottom = "";
                    td.style.borderRight = "";
                    td.style.borderLeft = "";
                    td.style.borderTopLeftRadius = "";
                    td.style.borderTopRightRadius = "";
                    td.style.borderBottomLeftRadius = "";
                    td.style.borderBottomRightRadius = "";
                    td.style.borderBottomWidth = "0px";

                    if (firstTd.hasAttribute("rowspan")) {
                        currentGroupLastRowIndex = index + firstTd.rowSpan - 1;
                        firstTd.style.borderTopLeftRadius = "8px"; // Round the top left corner
                        firstTd.style.borderBottomLeftRadius = "8px"; // Round the bottom left corner
                        firstTd.style.borderLeft = "2px solid #005eef80"; // Add border on the left
                        firstTd.style.borderBottom = "2px solid #005eef80";
                        td.style.borderTop = "2px solid #005eef80";
                        if (i === tds.length - 1) {
                            td.style.borderTopRightRadius = "8px"; // Round the top left corner
                            td.style.borderRight = "2px solid #005eef80";
                        }
                    } else if (i === tds.length - 1) {
                        td.style.borderRight = "2px solid #005eef80";
                    }

                    // identifying the last row and put bottom border
                    if (currentGroupLastRowIndex === index && i < tds.length - 1) {
                        td.style.borderBottom = "2px solid #005eef80";
                    } else if (currentGroupLastRowIndex === index && i === tds.length - 1) {
                        td.style.borderBottomRightRadius = "8px";
                        td.style.borderBottom = "2px solid #005eef80";
                    }
                });
            });
        }
    }, []);

    // useEffect hook to call addBorders after a delay upon certain dependencies changing
    useEffect(() => {
        if (moduleName === "overall") {
            // Set a timeout to delay the execution of addBorders function
            const addBr = setTimeout(() => {
                if (!hasActuallyMoved) {
                    addBorders(); // Call the addBorders function after the delay
                }
            }, 10); // Wait for 10 milliseconds

            // Cleanup function to clear the timeout if the component unmounts or dependencies change
            return () => clearTimeout(addBr);
        }
    }, [addBorders, mappings, draggableColumns, productColumnVisibility, overallToggle, hasActuallyMoved, overallAnalysisTypeValue, moduleName, isITMDataShown]); // Dependencies that trigger the effect

    const getActionStandard = useCallback(() => {
        if (selectedStudy.length === 1) {
            const coreDataId = selectedStudy[0]?.id || null;
            if (coreDataId) {
                const url = process.env.REACT_APP_SERVER_PATH + `/action-standard-groups/submit/kpis/?archive=False&core_data_model=${coreDataId}`;
                try {
                    api.get(url)
                        .then(async (res) => {
                            const response = res.data;
                            const kpis = new Set(
                                response.flatMap((datum) => {
                                    const _kpi = datum?.action_standard_kpis?.map((item) => item?.kpi || []);
                                    return _kpi.flat();
                                })
                            );
                            setActionStandardKpis([...kpis]);
                            setActionStandardData(response);
                        })
                        .catch(async (error) => {
                            handleError("error", error);
                        });
                } catch (error) {
                    handleError("error", error);
                }
            }
        }
    }, [selectedStudy, moduleName, isOralCare]);

    useEffect(() => {
        getActionStandard();
    }, [getActionStandard]);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const getSignificanceBoxAnalysisSelection = () => {
        const result = boxAnalysisTypeSelection.filter((item) =>
            (testAnalysisType || "")
                .toLowerCase()
                .split(",")
                .map((v) => v.trim().split("_")[0])
                .some((key) => item.toLowerCase().includes(key))
        );
        return result;
    };

    const returnTableHeader = () => {
        const significanceBoxAnalysisSelection = getSignificanceBoxAnalysisSelection();
        return (
            <tr>
                {stickyColumns.map((col, i) => {
                    return i === 0 ? (
                        // <TableCellWithInnerSeparator
                        //     key={col + i}
                        //     value={col}
                        //     cellType="th"
                        //     testLabel=""
                        //     styles={{
                        //         main: {
                        //             minWidth: moduleName === "claims" ? 300 : 200,
                        //             maxWidth: moduleName === "claims" ? 300 : 200,
                        //             position: "sticky",
                        //             left: 0,
                        //             zIndex: 2,
                        //         },
                        //         wrapper: {},
                        //         value: {
                        //             alignItems: "center",
                        //         },
                        //     }}
                        //     mainProps={{
                        //         colSpan: 2,
                        //         align: "center",
                        //     }}
                        // />
                        <th
                            key={col + i}
                            colSpan="2"
                            style={{
                                minWidth: 200,
                                maxWidth: 200,
                                position: "sticky",
                                left: "0",
                                zIndex: 2,
                            }}
                        ></th>
                    ) : (
                        <TableCellWithOuterSeparator
                            key={col + i}
                            value={col}
                            cellType="th"
                            testLabel=""
                            styles={{
                                main: {
                                    minWidth: 300,
                                    maxWidth: moduleName === "claims" ? 500 : 300,
                                    position: "sticky",
                                    left: moduleName === "claims" ? 300 : 200,
                                    zIndex: 2,
                                },
                                wrapper: {
                                    justifyContent: "space-between",
                                },
                                value: {
                                    alignItems: "center",
                                },
                            }}
                        />
                    );
                })}
                {significanceToggle && (
                    <TableCellWithOuterSeparator
                        value="Significance (p value)"
                        cellType="th"
                        testLabel=""
                        mainProps={{
                            colSpan: box ? significanceBoxAnalysisSelection.length : 1,
                            align: "center",
                        }}
                        styles={{
                            main: {
                                minWidth: 200,
                                maxWidth: 200,
                                zIndex: 2,
                            },
                            wrapper: {},
                            value: {
                                justifyContent: "center",
                                alignItems: "center",
                            },
                        }}
                    />
                )}
                {box && (
                    <TableCellWithOuterSeparator
                        value="Box Type Analysis"
                        cellType="th"
                        testLabel=""
                        mainProps={{
                            colSpan: boxAnalysisTypeSelection.length,
                        }}
                        styles={{
                            main: {
                                minWidth: 200,
                                maxWidth: 200,
                                zIndex: 2,
                            },
                            wrapper: {
                                justifyContent: "center",
                            },
                            value: {
                                justifyContent: "center",
                                alignItems: "center",
                            },
                        }}
                    />
                )}
                {isITMDataShown && overallToggle && !["claims"].includes(moduleName) && (
                    <TableCellWithOuterSeparator
                        value={
                            <>
                                <div
                                    style={{
                                        textAlign: "center",
                                    }}
                                >
                                    ITM Overall Sample <br /> <span className="text-xs">(All Products Combined)</span>
                                </div>
                                <HeaderSampleSize
                                    draggableColumns={draggableColumns}
                                    productColumnVisibility={productColumnVisibility}
                                    isProductHeader={false}
                                />
                            </>
                        }
                        cellType="th"
                        testLabel=""
                        mainProps={{
                            colSpan: box ? boxAnalysisTypeSelection.length : 1,
                            align: "center",
                        }}
                        styles={{
                            main: {
                                minWidth: 200,
                                maxWidth: 200,
                                zIndex: 2,
                            },
                            wrapper: {},
                            value: {
                                justifyContent: "space-between",
                                flexDirection: "column",
                            },
                        }}
                    />
                )}{" "}
                {/*box analysis and itm*/}
                {overallToggle && !["claims"].includes(moduleName) && (
                    <TableCellWithOuterSeparator
                        value={
                            <>
                                <div style={{ textAlign: "center" }}>
                                    {isITMDataShown && overallToggle && "Recall "}Overall Sample <br /> <span className="text-xs">(All Products Combined)</span>
                                </div>
                                <HeaderSampleSize
                                    draggableColumns={draggableColumns}
                                    productColumnVisibility={productColumnVisibility}
                                    isProductHeader={false}
                                />
                            </>
                        }
                        cellType="th"
                        testLabel=""
                        mainProps={{
                            colSpan: box ? boxAnalysisTypeSelection.length : 1,
                            align: "center",
                        }}
                        styles={{
                            main: {
                                minWidth: 200,
                                maxWidth: 200,
                                zIndex: 2,
                            },
                            wrapper: {},
                            value: {
                                justifyContent: "space-between",
                                flexDirection: "column",
                            },
                        }}
                    />
                )}
                {draggableColumns.map((datum, index) => {
                    let productCodeTitle = datum.title;
                    const productCodeCoreDataId = datum.coreDataId;
                    const className = getProductColumnClassName(productCodeTitle, productCodeCoreDataId, productColumnVisibility);
                    let studyReferenceOrTestCode = selectedStudy?.find((study) => study.id === datum.coreDataId)?.study_reference__title;
                    const showWeightIcon = selectedStudy.length > 1 && selectedStudy?.find((study) => study.id === datum.coreDataId)?.weighted === true;
                    if (isOralCare) {
                        const [title, code] = getOralCareProductCodeTableHeader(datum, productsTestCodeMapData);
                        productCodeTitle = title;
                        studyReferenceOrTestCode = (
                            <>
                                {code} / {studyReferenceOrTestCode}
                            </>
                        );
                    }
                    return (
                        <TableCellWithOuterSeparator
                            key={index + 1 + datum.title + "pc"}
                            value={
                                targetColumnIndex === index && hasActuallyMoved ? (
                                    ""
                                ) : (
                                    <>
                                        {showWeightIcon && (
                                            <img
                                                alt="weightToggle"
                                                style={{
                                                    width: 14,
                                                    marginRight: 10,
                                                }}
                                                src={WeightToggleIcon}
                                            />
                                        )}
                                        <button
                                            className="clean-button color-blue"
                                            style={{
                                                fontWeight: 600,
                                                fontSize: "0.875rem",
                                            }}
                                            onClick={(e) =>
                                                handleProductClick(e, {
                                                    coreDataId: datum.coreDataId,
                                                    productCode: datum.title,
                                                })
                                            }
                                        >
                                            {productCodeTitle} / {studyReferenceOrTestCode}
                                        </button>

                                        <HeaderSampleSize productData={datum} />
                                    </>
                                )
                            }
                            cellType="th"
                            testLabel=""
                            mainProps={{
                                colSpan: tableHeadSpan,
                                draggable: true,
                                onDragStart: (e) => handleColumnDragStart(e, index),
                                onDragOver: handleDragOver,
                                onDrop: () => handleColumnDrop(index),
                                align: "center",
                                className: className,
                            }}
                            styles={{
                                main: {
                                    fontWeight: "600",
                                    cursor: "move",
                                    minWidth: targetColumnIndex === index && hasActuallyMoved ? draggedColumnDiamension.width : 200,
                                    maxWidth: targetColumnIndex === index && hasActuallyMoved ? draggedColumnDiamension.height : 300,
                                    background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                                    borderColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                                },
                                wrapper: {
                                    justifyContent: "space-between",
                                },
                                value: {
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                    alignItems: "center",
                                },
                            }}
                        />
                    );
                })}
            </tr>
        );
    };

    const getConsumerFilter = (datum) => {
        if (isConsumerFilterLoadingStoreData) {
            return <CircularProgress size={20} />;
        } else {
            return (
                <ConsumerFilter
                    productsSecondaryData={draggableColumns}
                    product={datum}
                    handleFilterSubmit={handleFilterSubmit}
                />
            );
        }
    };

    const returnConsumerFilterRow = () => {
        const significanceBoxAnalysisSelection = getSignificanceBoxAnalysisSelection();
        return (
            <tr>
                {moduleName === "claims" ? (
                    <>
                        <th
                            key={"col-cf"}
                            scope="col"
                            style={{
                                minWidth: 300,
                                maxWidth: 300,
                                position: "sticky",
                                left: 0,
                                zIndex: 2,
                            }}
                        >
                            <ClaimsTerritoryFilter
                                claimsTerritoryTags={claimsTerritoryTags}
                                page={"claimsAnalysis"}
                            />
                            {claimsTerritorySelectedTags.length !== 0 && (
                                <div
                                    style={{
                                        margin: "10px",
                                    }}
                                >
                                    {claimsTerritorySelectedTags.map((tag, i) => {
                                        return (
                                            <span
                                                key={i + 1 + tag}
                                                style={{
                                                    backgroundColor: "#b8c7ed",
                                                    borderRadius: "5px",
                                                    padding: "0px 3px",
                                                    display: "inline-block",
                                                    margin: "3px 2px",
                                                    fontSize: "8px",
                                                    letterSpacing: "1px",
                                                }}
                                            >
                                                {tag}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                        </th>
                        <th
                            key={"col-txt"}
                            scope="col"
                            style={{
                                minWidth: 300,
                                maxWidth: 500,
                                position: "sticky",
                                left: 300,
                                zIndex: 2,
                            }}
                        >
                            <TextField
                                fullWidth
                                placeholder="Search"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    style: {
                                        height: "30px",
                                        fontSize: "14px",
                                    },
                                }}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                        </th>
                    </>
                ) : (
                    stickyColumns.map((col, i) => {
                        return (
                            <th
                                key={col + i + "sticky-col"}
                                scope="col"
                                style={{
                                    minWidth: 200,
                                    maxWidth: 200,
                                    position: "sticky",
                                    left: i * 200,
                                    zIndex: 2,
                                }}
                                colSpan="2"
                            ></th>
                        );
                    })
                )}
                {significanceToggle && (
                    <td
                        colSpan={box ? significanceBoxAnalysisSelection.length : 1}
                        style={{
                            minWidth: 200,
                            maxWidth: 200,
                            textAlign: "center",
                            fontWeight: "500",
                        }}
                    >
                        {tTestLegends[0]?.title && tTestLegends[1]?.title && overallFragranceToggle ? (
                        <p
                            style={{
                                fontSize: "12px",
                                marginLeft: "30px",
                                marginRight: "30px",
                            }}
                        >
                            {`p-value comparison between ${tTestLegends[0]?.title} and ${tTestLegends[1]?.title}`}
                        </p>
                        ) : ""}
                    </td>
                )}
                {box && <td colSpan={boxAnalysisTypeSelection.length}></td>} {/*box analysis*/}
                {isITMDataShown && overallToggle && !["claims"].includes(moduleName) && <td colSpan={box ? boxAnalysisTypeSelection.length : 1}></td>} {/*box analysis and itm*/}
                {overallToggle && !["claims"].includes(moduleName) && <td colSpan={box ? boxAnalysisTypeSelection.length : 1}></td>}
                {draggableColumns.map((datum, index) => {
                    const productCodeTitle = datum.title;
                    const productCodeCoreDataId = datum.coreDataId;
                    const className = getProductColumnClassName(productCodeTitle, productCodeCoreDataId, productColumnVisibility);
                    return (
                        <td
                            key={index + 1 + "cf"}
                            colSpan={tableHeadSpan}
                            className={className}
                            style={{
                                textAlign: "center",
                                fontWeight: "500",
                                padding: "6px 0px",
                                background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                                borderColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "#fff",
                            }}
                        >
                            {targetColumnIndex === index && hasActuallyMoved ? "" : getConsumerFilter(datum)}
                        </td>
                    );
                })}
            </tr>
        );
    };

    const returnItmRecallLabelRow = () => {
        return (
            <tr>
                {stickyColumns.map((col, i) => {
                    return (
                        <th
                            key={col + i + "itm-recall"}
                            scope="col"
                            style={{
                                minWidth: 200,
                                maxWidth: 200,
                                position: "sticky",
                                left: i * 200,
                                zIndex: 2,
                            }}
                        ></th>
                    );
                })}
                {box && <td colSpan={boxAnalysisTypeSelection.length}></td>} {/*box analysis*/}
                {isITMDataShown && overallToggle && !["claims"].includes(moduleName) && <td colSpan={box ? dataViewKey.split(",").length : 1}></td>} {/*box analysis and itm*/}
                {overallToggle && !["claims"].includes(moduleName) && <td colSpan={box ? dataViewKey.split(",").length : 1}></td>}
                {draggableColumns.map((datum, index) => {
                    const productCodeTitle = datum.title;
                    const productCodeCoreDataId = datum.coreDataId;
                    const className = getProductColumnClassName(productCodeTitle, productCodeCoreDataId, productColumnVisibility);

                    const key = index + 1 + productCodeTitle;
                    return (
                        <>
                            {
                                <TableCellWithOuterSeparator
                                    key={key + "itm"}
                                    value={targetColumnIndex === index && hasActuallyMoved ? "" : "ITM"}
                                    cellType="td"
                                    testLabel=""
                                    mainProps={{
                                        className: `${className}`,
                                        colSpan: isITMDataShown && !box ? 1 : dataViewKey.split(",").length,
                                    }}
                                    styles={{
                                        main: {
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                                        },
                                        wrapper: {},
                                        value: {
                                            justifyContent: "center",
                                            color: "#005eef",
                                            background: "#f0f8ff",
                                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                            fontWeight: "600",
                                            borderRadius: "5px",
                                            padding: "5px",
                                        },
                                    }}
                                />
                            }
                            <TableCellWithOuterSeparator
                                key={key + "recall-mean"}
                                value={targetColumnIndex === index && hasActuallyMoved ? "" : "Recall"}
                                cellType="td"
                                testLabel=""
                                mainProps={{
                                    className: `${className}`,
                                    colSpan: dataViewKey.split(",").length,
                                }}
                                styles={{
                                    main: {
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                                    },
                                    wrapper: {},
                                    value: {
                                        justifyContent: "center",
                                        color: "#005eef",
                                        background: "#f0f8ff",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        fontWeight: "600",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                                showSeperator={false}
                            />
                        </>
                    );
                })}
            </tr>
        );
    };

    const returnBoxAnalysisLabelRow = () => {
        const significanceBoxAnalysisSelection = getSignificanceBoxAnalysisSelection();
        return (
            <tr>
                {stickyColumns.map((col, i) => {
                    const isFirst = i === 0;
                    const minWid = isFirst ? 200 : 300;

                    const maxWid = isFirst ? 200 : 300;

                    const leftSpace = isFirst ? 0 : 200;

                    return (
                        <th
                            key={col + i + "box"}
                            scope="col"
                            style={{
                                minWidth: minWid,
                                maxWidth: maxWid,
                                position: "sticky",
                                left: leftSpace,
                                zIndex: 2,
                            }}
                        ></th>
                    );
                })}
                {significanceToggle &&
                    box &&
                    significanceBoxAnalysisSelection.length > 0 &&
                    significanceBoxAnalysisSelection.map((ele, i) => {
                        const key = "box-analysis-label-column-" + i;
                        return (
                            <TableCellWithOuterSeparator
                                key={key}
                                value={ele}
                                cellType="td"
                                testLabel=""
                                mainProps={{
                                    colSpan: 1,
                                }}
                                styles={{
                                    main: {},
                                    wrapper: {},
                                    value: {
                                        justifyContent: "center",
                                        color: "#005eef",
                                        background: "#f0f8ff",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        fontWeight: "600",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                                showSeperator={ele !== "Bottom Box"}
                            />
                        );
                    })}
                {boxAnalysisTypeSelection.map((ele, i) => {
                    const key = "box-analysis-label-column-" + i;
                    return (
                        <TableCellWithOuterSeparator
                            key={key}
                            value={ele}
                            cellType="td"
                            testLabel=""
                            styles={{
                                main: {},
                                wrapper: {},
                                value: {
                                    justifyContent: "center",
                                    color: "#005eef",
                                    background: "#f0f8ff",
                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                    fontWeight: "600",
                                    borderRadius: "5px",
                                    padding: "5px",
                                },
                            }}
                            showSeperator={ele !== "Bottom Box"}
                        />
                    );
                })}
                {isITMDataShown &&
                    overallToggle &&
                    !["claims"].includes(moduleName) &&
                    boxAnalysisTypeSelection.map((ele, i) => {
                        const key = "box-analysis-itm-label-column-" + i;
                        return (
                            <TableCellWithOuterSeparator
                                key={key}
                                value={ele}
                                cellType="td"
                                testLabel=""
                                styles={{
                                    main: {},
                                    wrapper: {},
                                    value: {
                                        justifyContent: "center",
                                        color: "#005eef",
                                        background: "#f0f8ff",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        fontWeight: "600",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                                showSeperator={ele !== "Bottom Box"}
                            />
                        );
                    })}
                {overallToggle &&
                    !["claims"].includes(moduleName) &&
                    boxAnalysisTypeSelection.map((ele, i) => {
                        const key = "box-analysis-recall-label-column-" + i;
                        return (
                            <TableCellWithOuterSeparator
                                key={key}
                                value={ele}
                                cellType="td"
                                testLabel=""
                                styles={{
                                    main: {},
                                    wrapper: {},
                                    value: {
                                        justifyContent: "center",
                                        color: "#005eef",
                                        background: "#f0f8ff",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        fontWeight: "600",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                                showSeperator={ele !== "Bottom Box"}
                            />
                        );
                    })}
                {box &&
                    draggableColumns.map((datum, index) => {
                        const productCodeTitle = datum.title;
                        const productCodeCoreDataId = datum.coreDataId;
                        const className = getProductColumnClassName(productCodeTitle, productCodeCoreDataId, productColumnVisibility);
                        return (
                            <>
                                {isITMDataShown &&
                                    boxAnalysisTypeSelection.map((ele, i) => {
                                        const key = "box-analysis-itm-product-label-column-" + index + "-" + i;
                                        return (
                                            <TableCellWithOuterSeparator
                                                key={key}
                                                value={targetColumnIndex === index && hasActuallyMoved ? "" : ele}
                                                cellType="td"
                                                testLabel=""
                                                mainProps={{
                                                    className: className,
                                                }}
                                                styles={{
                                                    main: {
                                                        fontWeight: "600",
                                                        cursor: "pointer",
                                                        background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                                                    },
                                                    wrapper: {},
                                                    value: {
                                                        justifyContent: "center",
                                                        color: "#005eef",
                                                        background: "#f0f8ff",
                                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                        fontWeight: "600",
                                                        borderRadius: "5px",
                                                        padding: "5px",
                                                    },
                                                }}
                                                showSeperator={ele !== "Bottom Box"}
                                            />
                                        );
                                    })}
                                {boxAnalysisTypeSelection.map((ele, i) => {
                                    const key = "box-analysis-recall-product-label-column-" + index + "-" + i;
                                    const label = ele;
                                    return (
                                        <TableCellWithOuterSeparator
                                            key={key}
                                            value={targetColumnIndex === index && hasActuallyMoved ? "" : label}
                                            cellType="td"
                                            testLabel=""
                                            mainProps={{
                                                className: className,
                                            }}
                                            styles={{
                                                main: {
                                                    fontWeight: "600",
                                                    cursor: "pointer",
                                                    background: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "",
                                                },
                                                wrapper: {},
                                                value: {
                                                    justifyContent: "center",
                                                    color: "#005eef",
                                                    background: "#f0f8ff",
                                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                    fontWeight: "600",
                                                    borderRadius: "5px",
                                                    padding: "5px",
                                                },
                                            }}
                                            showSeperator={ele !== "Bottom Box"}
                                        />
                                    );
                                })}
                            </>
                        );
                    })}
            </tr>
        );
    };

    const returnAnalysisScoresRow = () => {
        const [key1, key2] = getViewKeys(dataViewKey);

        const variableForSorting = isUnileverFragranceHouse ? "R_OOF" : "R_OO_Frag_10pt";
        const filteredDisplayLabels = fragranceAssociationMappings?.[0]?.displayLabels?.filter((ele) => ele.backendVariable === variableForSorting);
        const finalData = [
            {
                displayLabels: filteredDisplayLabels,
                macroCategory: fragranceAssociationMappings?.[0]?.macroCategory,
            },
        ];

        const _roww = finalData.map((catObj, i) => {
            const kpis = catObj?.displayLabels || [];
            const { rowSpan, productScoreWithNaObj } = getProductScoreWithNaAndRowSpan({ catObj, box, key1, key2, isITMDataShown, moduleName, overallFragrance, noOfProducts, removedKpiStoreState });
            const groductScoreSumObject = getProductScoreSumObject({ catObj, box, key1, key2, isITMDataShown, moduleName, overallFragrance, productColumnVisibility });
            let ifAvailableFirstRow = true;
            const uniqueKpis = new Set();
            const _trs = kpis
                .map((bvObj) => {
                    const rowDisplayLabel = bvObj.displayLabel;
                    const rowBackendVariable = bvObj.backendVariable;
                    let firstColumn = true;
                    if (!uniqueKpis.has(bvObj.displayLabel)) {
                        if (!ifAvailableFirstRow && catObj.displayLabels?.length >= 2) {
                            firstColumn = false;
                        }
                        const { recallBvObj, itmBvObj } = getRecallAndITM(rowDisplayLabel, rowBackendVariable, moduleName, kpis);

                        const productsScoreWithNA = productScoreWithNaObj[rowDisplayLabel];
                        const { itmTopOrMeanKey1, itmbottomKey2, recallTopOrMeanKey1, recallbottomKey2 } = groductScoreSumObject[rowDisplayLabel];
                        const rowMacroCategoryLabel = catObj.macroCategory.charAt(0).toUpperCase() + catObj.macroCategory.slice(1);
                        let rowBackendVariableDisplayLabel = bvObj.displayLabel.charAt(0).toUpperCase() + bvObj.displayLabel.slice(1);
                        // if (likertScaleData?.[bvObj.backendVariable] && moduleName !== "claims") {
                        //     rowBackendVariableDisplayLabel += ` (${likertScaleData[bvObj.backendVariable]})`;
                        // }
                        const showActionStandard = actionStandardKpis.includes(bvObj.backendVariable) && (selectedStudy.length === 1 || isITMDataShown);
                        if (showActionStandard) {
                            rowBackendVariableDisplayLabel += "*";
                        }
                        const label = highlightText(rowBackendVariableDisplayLabel, searchValue);
                        const selectionFilteredData = boxAnalysisSelection[moduleName === "overall" && Object.keys(recallBvObj).length === 0 ? itmBvObj.backendVariable : recallBvObj.backendVariable];
                        const testResult = tTestResult?.find((resObj) => resObj.backendVariable === rowBackendVariable);
                        const significanceBoxAnalysisSelection = getSignificanceBoxAnalysisSelection();
                        const row = (
                            <tr
                                key={i + 1 + "row" + rowBackendVariable}
                                className="score-row"
                            >
                                {firstColumn && (moduleName === "overall" || moduleName === "claims" || moduleName === "fragranceMetrics" || moduleName === "fragranceAssociation") && (
                                    <TableCellWithInnerSeparator
                                        key={catObj.macroCategory + "first-co" + i}
                                        value={
                                            moduleName === "claims" ? (
                                                <div
                                                    style={{
                                                        wordWrap: "break-word",
                                                        whiteSpace: "normal",
                                                    }}
                                                >
                                                    {rowMacroCategoryLabel.split(",").map((tag, i) => {
                                                        const key = i + 1 + tag;
                                                        return (
                                                            <div
                                                                key={key}
                                                                style={{
                                                                    backgroundColor: "#D8E8FE",
                                                                    borderRadius: "5px",
                                                                    padding: "2px 6px",
                                                                    display: "inline-block",
                                                                    margin: "3px 6px",
                                                                }}
                                                            >
                                                                {tag}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                rowMacroCategoryLabel
                                            )
                                        }
                                        cellType="td"
                                        testLabel=""
                                        mainProps={{
                                            rowSpan: rowSpan,
                                        }}
                                        styles={{
                                            main: {
                                                minWidth: 280,
                                                maxWidth: 280,
                                                left: 0,
                                                position: "sticky",
                                                zIndex: 2,
                                            },
                                            wrapper: {
                                                background: "#fff",
                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                borderRadius: "5px",
                                                padding: "5px",
                                            },
                                            value: {
                                                alignItems: "center",
                                            },
                                        }}
                                    />
                                )}
                                {moduleName === "overall" || moduleName === "claims" || moduleName === "fragranceMetrics" || moduleName === "fragranceAssociation" ? (
                                    <TableCellWithOuterSeparator
                                        value={
                                            <>
                                                {box && boxAnalysisTypeSelection.length > 1 && (
                                                    <OverlappingScales
                                                        topBoxSelection={selectionFilteredData?.top_box}
                                                        bottomBoxSelection={selectionFilteredData?.bottom_box}
                                                    />
                                                )}
                                                <span style={{ textAlign: "left" }}>
                                                    <span dangerouslySetInnerHTML={{ __html: label }} />
                                                </span>
                                            </>
                                        }
                                        cellType="td"
                                        testLabel=""
                                        styles={{
                                            main: {
                                                left: 280,
                                                position: "sticky",
                                                fontWeight: showActionStandard ? 600 : 500, // Bold only for single study
                                                zIndex: 2,
                                            },
                                            wrapper: {},
                                            value: {
                                                background: "#fff",
                                                whiteSpace: "nowrap",
                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                borderRadius: "5px",
                                                padding: "5px",
                                            },
                                        }}
                                    />
                                ) : (
                                    <TableCellWithInnerSeparator
                                        value={
                                            <>
                                                {box && boxAnalysisTypeSelection.length > 1 && (
                                                    <OverlappingScales
                                                        topBoxSelection={selectionFilteredData?.top_box}
                                                        bottomBoxSelection={selectionFilteredData?.bottom_box}
                                                    />
                                                )}
                                                <span style={{ textAlign: "left" }}>
                                                    <span dangerouslySetInnerHTML={{ __html: label }} />
                                                </span>
                                            </>
                                        }
                                        cellType="td"
                                        testLabel=""
                                        styles={{
                                            main: {
                                                left: 0,
                                                position: "sticky",
                                                fontWeight: showActionStandard ? 600 : 500, // Bold only for single study
                                                zIndex: 2,
                                            },
                                            wrapper: {},
                                            value: {
                                                background: "#fff",
                                                whiteSpace: "nowrap",
                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                borderRadius: "5px",
                                                padding: "5px",
                                            },
                                        }}
                                    />
                                )}
                                {significanceToggle &&
                                    (box && significanceBoxAnalysisSelection.length > 0 ? (
                                        significanceBoxAnalysisSelection.map((ele, i) => {
                                            const boxType = ele.split(" ")[0].toLowerCase();
                                            const pValueKey = boxType === "top" ? "top_significance" : "bottom_significance";
                                            const pValue = testResult?.[pValueKey] || testResult?.significance_pvalue || "";

                                            return (
                                                <TableCellWithOuterSeparator
                                                    key={`significance-${boxType}-${i}`}
                                                    value={pValue}
                                                    cellType="td"
                                                    testLabel=""
                                                    mainProps={{
                                                        colSpan: 1,
                                                    }}
                                                    styles={{
                                                        main: {},
                                                        wrapper: {},
                                                        value: {
                                                            justifyContent: "center",
                                                            background: pValue ? "#fff" : "#eee",
                                                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                            borderRadius: "5px",
                                                            padding: "5px",
                                                        },
                                                    }}
                                                    showSeperator={ele !== "Bottom Box"}
                                                />
                                            );
                                        })
                                    ) : (
                                        <TableCellWithOuterSeparator
                                            value={testResult?.significance_pvalue || ""}
                                            cellType="td"
                                            testLabel=""
                                            styles={{
                                                main: {},
                                                wrapper: {},
                                                value: {
                                                    justifyContent: "center",
                                                    background: testResult?.significance_pvalue ? "#fff" : "#eee",
                                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                    borderRadius: "5px",
                                                    padding: "5px",
                                                },
                                            }}
                                        />
                                    ))}
                                {box &&
                                    boxAnalysisTypeSelection.map((ele, i) => {
                                        const key = "box-analysis-selection-column-" + i;
                                        // return ( <td key={key}>{getSelectedOption(ele.split(" ")[0].toLowerCase(), selectionFilteredData)}</td>)
                                        return (
                                            <TableCellWithOuterSeparator
                                                key={key}
                                                value={getSelectedOption(ele.split(" ")[0].toLowerCase(), selectionFilteredData)}
                                                cellType="td"
                                                testLabel=""
                                                styles={{
                                                    main: {},
                                                    wrapper: {},
                                                    value: {
                                                        justifyContent: "center",
                                                        background: "#fff",
                                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                        borderRadius: "5px",
                                                        padding: "5px",
                                                    },
                                                }}
                                                showSeperator={ele !== "Bottom Box"}
                                            />
                                        );
                                    })}
                                {isITMDataShown &&
                                    overallToggle &&
                                    !["claims"].includes(moduleName) &&
                                    dataViewKey.split(",").map((ele, i) => {
                                        const key = "box-analysis-overall-itm-value-column-" + i;
                                        return (
                                            <TableCellWithOuterSeparator
                                                key={key}
                                                value={getOverallCalculationResult(i === 0 ? itmTopOrMeanKey1 : itmbottomKey2, totalSampleSize, totalVisibleProducts, ele)}
                                                cellType="td"
                                                testLabel=""
                                                styles={{
                                                    main: {},
                                                    wrapper: {},
                                                    value: {
                                                        justifyContent: "center",
                                                        background: "#fff",
                                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                        borderRadius: "5px",
                                                        padding: "5px",
                                                    },
                                                }}
                                                showSeperator={!ele.startsWith("bottom")}
                                            />
                                        );
                                    })}
                                {overallToggle &&
                                    !["claims"].includes(moduleName) &&
                                    dataViewKey.split(",").map((ele, i) => {
                                        const key = "box-analysis-overall-recall-value-column-" + i;
                                        return (
                                            <TableCellWithOuterSeparator
                                                key={key}
                                                value={getOverallCalculationResult(i === 0 ? recallTopOrMeanKey1 : recallbottomKey2, totalSampleSize, totalVisibleProducts, ele)}
                                                cellType="td"
                                                testLabel=""
                                                styles={{
                                                    main: {},
                                                    wrapper: {},
                                                    value: {
                                                        justifyContent: "center",
                                                        background: "#fff",
                                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                        borderRadius: "5px",
                                                        padding: "5px",
                                                    },
                                                }}
                                                showSeperator={!ele.startsWith("bottom")}
                                            />
                                        );
                                    })}
                                {draggableColumns.map((faData, index) => {
                                    const datum = overallFragrance?.find((ele) => ele.title === faData.title);
                                    let recallScore = null;
                                    let itmBvScore = null;
                                    let recallTest = null;
                                    let itmTest = null;
                                    const productCodeCoreDataId = datum.coreDataId;
                                    if (moduleName === "overall") {
                                        recallScore = getScoreByVariable(datum.scores, recallBvObj?.backendVariable);
                                        recallTest = getTestResultByVariable(tTestResult, recallBvObj?.backendVariable, productCodeCoreDataId);
                                        if (isITMDataShown) {
                                            itmBvScore = getScoreByVariable(datum.scores, itmBvObj?.backendVariable);
                                            itmTest = getTestResultByVariable(tTestResult, itmBvObj?.backendVariable, productCodeCoreDataId);
                                        }
                                    } else {
                                        const filteredBvObjScore = kpis.find((ele) => ele.displayLabel === rowDisplayLabel) || {};
                                        recallScore = getScoreByVariable(datum.scores, filteredBvObjScore?.backendVariable);
                                        recallTest = getTestResultByVariable(tTestResult, filteredBvObjScore?.backendVariable, productCodeCoreDataId);
                                    }

                                    const productCodeTitle = datum.title;

                                    const className = getProductColumnClassName(productCodeTitle, productCodeCoreDataId, productColumnVisibility);
                                    // const recallTestResult = getColorsAndLetterForIctAgreement(testAnalysisType, productCodeTitle, recallTest);
                                    const itmTestResult = getColorsAndLetter(testAnalysisType, productCodeTitle, itmTest);
                                    // console.log("recallTestResult",testAnalysisType,recallTest,recallTestResult)
                                    let colorObj = null;
                                    if (recallTest) {
                                        colorObj = recallTest?.colors?.find((obj) => obj.productCode === productCodeTitle) || {};
                                    }
                                    return (
                                        <>
                                            {isITMDataShown &&
                                                dataViewKey.split(",").map((ele, k) => {
                                                    const key = "box-analysis-itm-value-column-" + index + "-" + k;

                                                    return (
                                                        <TableCellWithOuterSeparator
                                                            key={key}
                                                            value={targetColumnIndex === index && hasActuallyMoved ? "" : getFormattedScoreOrNA(itmBvScore[dataViewKey.split(",")[k]], ele.split(",")[0])}
                                                            cellType="td"
                                                            testLabel={itmTestResult?.["label"] ?? null}
                                                            mainProps={{
                                                                className: className,
                                                            }}
                                                            styles={{
                                                                main: {
                                                                    backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "#fff",
                                                                    border: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                                                                    outline: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                                                                },
                                                                wrapper: {},
                                                                value: {
                                                                    justifyContent: "center",
                                                                    background: itmTestResult?.["color"]?.[ele] ?? "#fff",
                                                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                                    borderRadius: "5px",
                                                                    padding: "5px",
                                                                },
                                                            }}
                                                            showSeperator={!ele.startsWith("bottom")}
                                                        />
                                                    );
                                                })}
                                            {dataViewKey.split(",").map((ele, k) => {
                                                const key = "box-analysis-recall-value-column-" + index + "-" + k;
                                                return (
                                                    <TableCellWithOuterSeparator
                                                        key={key}
                                                        value={targetColumnIndex === index && hasActuallyMoved ? "" : getFormattedScoreOrNA(recallScore[dataViewKey.split(",")[k]], ele.split(",")[0])}
                                                        cellType="td"
                                                        testLabel={colorObj?.["label"] ?? null}
                                                        mainProps={{
                                                            className: className,
                                                        }}
                                                        styles={{
                                                            main: {
                                                                backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "#fff",
                                                                border: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                                                                outline: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                                                            },
                                                            wrapper: {},
                                                            value: {
                                                                justifyContent: "center",
                                                                background: colorObj?.["common"] ?? "#fff",
                                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                                borderRadius: "5px",
                                                                padding: "5px",
                                                            },
                                                        }}
                                                        showSeperator={ele.startsWith("bottom") ? false : isITMDataShown}
                                                    />
                                                );
                                            })}
                                        </>
                                    );
                                })}
                            </tr>
                        );

                        if (productsScoreWithNA === noOfProducts) {
                            return null;
                        } else if (moduleName !== "claims" && removedKpiStoreState.flatMap((item) => item.split(",")).includes(bvObj.backendVariable)) {
                            return;
                        } else if (moduleName === "claims" && removedKpiStoreState.includes(bvObj.backendVariable)) {
                            return;
                        } else {
                            ifAvailableFirstRow = false;
                            uniqueKpis.add(bvObj.displayLabel);
                            return row;
                        }
                    } else {
                        return;
                    }
                })
                .filter((ele) => ele);
            let _tr = null;
            if (moduleName === "overall" && _trs.length > 0) {
                _tr = (
                    <>
                        {_trs}
                        <tr className="gap">{gapRow({ length: overallFragrance.length, hiddenProductsCount, box, boxAnalysisTypeSelection, isITMDataShown, overallToggle, dataViewKey, targetColumnIndex, hasActuallyMoved })}</tr>
                    </>
                );
            } else {
                _tr = _trs;
            }

            return _tr;
        });
        return (
            <tbody>
                <tr>
                    <TableCellWithInnerSeparator
                        value={"Attribute Area"}
                        cellType="th"
                        testLabel=""
                        styles={{
                            main: {
                                left: 0,
                                position: "sticky",
                                fontWeight: "bold", // Bold only for single study
                                zIndex: 2,
                                minWidth: 280,
                            },
                            wrapper: {},
                            value: {
                                background: "#fff",
                                whiteSpace: "nowrap",
                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                borderRadius: "5px",
                                padding: "5px",
                            },
                        }}
                    />
                    <TableCellWithOuterSeparator
                        value={"Attribute"}
                        cellType="th"
                        testLabel=""
                        styles={{
                            main: {
                                left: 280,
                                position: "sticky",
                                fontWeight: "bold", // Bold only for single study
                                zIndex: 2,
                            },
                            wrapper: {},
                            value: {
                                background: "#fff",
                                whiteSpace: "nowrap",
                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                borderRadius: "5px",
                                padding: "5px",
                            },
                        }}
                    />
                </tr>
                {_roww}
                <tr>
                    <td
                        // colSpan={draggableColumns.length + 2}
                        colSpan={7}
                        style={{
                            position: "sticky",
                            left: 0,
                            maxWidth: "700px"
                        }}
                    >
                        {testLabel && tTestResult.length > 0 && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "40px"
                                }}
                            >
                                <span
                                    style={{
                                        marginBottom: "6px",
                                        color: "#495057",
                                        fontWeight: 600,
                                        fontSize: 12,
                                    }}
                                >
                                    {testLabel}
                                </span>
                                {!isFisher && tTestResult?.length !== 0 && tTestLegends?.length === 2 && (
                                    <ComparisonLegend
                                        legends={tTestLegends}
                                        moduleName={moduleName}
                                    />
                                )}
                            </div>
                        )}
                    </td>
                </tr>
            </tbody>
        );
    };

    const getAttributeList = (rowBackendVariable) => {
        let tempArr = [];
        draggableColumns?.forEach((datum) => {
            const attributeObj = datum?.scores?.find((ele) => ele.title === rowBackendVariable);
            const attributeArr = attributeObj?.attribute_values?.map((ele) => ele.attribute_value) || [];
            tempArr.push(...attributeArr);
        });
        const uniqueArr = [...new Set(tempArr)];
        const sortedArray = uniqueArr.sort((a, b) => a.localeCompare(b));
        return sortedArray;
    };
    
    const returnOverallAssociationRows = () => {
        const _roww = tableDataMapping.map((catObj) => {
            const kpis = catObj?.displayLabels || [];
            const macroCategory = catObj?.macroCategory;
            const _trs = kpis.map((bvObj) => {
                const rowBackendVariable = bvObj.backendVariable;
                const attributesArr = getAttributeList(rowBackendVariable);
                // const attributeObj = draggableColumns?.[0]?.scores?.find((ele) => ele.title === rowBackendVariable);
                // const attributesArr = attributeObj?.attribute_values?.map((ele) => ele.attribute_value) || [];
                // Only render rows if attributesArr has values
                if (attributesArr.length === 0) {
                    return null;
                }

                return getAttributeRows(attributesArr, rowBackendVariable, macroCategory);
            }).filter((row) => row !== null);

            return _trs;
        });

        return (
            <tbody>
                <tr>
                    {(activeTab === "Primary Fragrances Nodes & Fragrance Descriptors" || activeTab === "Descriptors") ? (
                        <>
                            <TableCellWithInnerSeparator
                                value={"Macro Variable - Micro Variable"}
                                cellType="th"
                                testLabel=""
                                mainProps={{
                                    colSpan: 1,
                                    align: "center",
                                }}
                                styles={{
                                    main: {
                                        left: 0,
                                        position: "sticky",
                                        fontWeight: "bold", // Bold only for single study
                                        zIndex: 2,
                                        minWidth: 280,
                                    },
                                    wrapper: {},
                                    value: {
                                        background: "#fff",
                                        whiteSpace: "nowrap",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                            />
                            <TableCellWithOuterSeparator
                                value={"Attribute Value"}
                                cellType="th"
                                testLabel=""
                                mainProps={{
                                    colSpan: 1,
                                    align: "center",
                                }}
                                styles={{
                                    main: {
                                        left: 280,
                                        position: "sticky",
                                        fontWeight: "bold", // Bold only for single study
                                        zIndex: 2,
                                    },
                                    wrapper: {},
                                    value: {
                                        background: "#fff",
                                        whiteSpace: "nowrap",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                            />
                        </>
                    ) : (
                        <TableCellWithInnerSeparator
                            value={"Attribute Value"}
                            cellType="th"
                            testLabel=""
                            mainProps={{
                                colSpan: 2,
                                align: "center",
                            }}
                            styles={{
                                main: {
                                    left: 0,
                                    position: "sticky",
                                    fontWeight: "bold", // Bold only for single study
                                    zIndex: 2,
                                },
                                wrapper: {},
                                value: {
                                    background: "#fff",
                                    whiteSpace: "nowrap",
                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                    borderRadius: "5px",
                                    padding: "5px",
                                },
                            }}
                        />
                    )}
                    {(significanceToggle && tTestFaLegends[0]?.title) && (
                        <td
                            colSpan={1}
                            style={{
                                minWidth: 200,
                                maxWidth: 200,
                                textAlign: "center",
                                fontWeight: "500",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "12px",
                                    marginLeft: "30px",
                                    marginRight: "30px",
                                }}
                            >
                                {`p-value comparison between ${tTestFaLegends[0]?.title} and ${tTestFaLegends[1]?.title}`}
                            </p>
                        </td>
                    )}
                </tr>
                {_roww}
                <tr>
                    <td
                        // colSpan={draggableColumns.length + 2}
                        colSpan={7}
                        style={{
                            position: "sticky",
                            left: 0,
                            maxWidth: "700px"
                        }}
                    >
                        {testLabel2 && tTestResult.length > 0 && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "40px"
                                }}
                            >
                                <span
                                    style={{
                                        marginBottom: "6px",
                                        color: "#495057",
                                        fontWeight: 600,
                                        fontSize: 12,
                                    }}
                                >
                                    {testLabel2}
                                </span>
                                <span>
                                    {!isFisher && tTestResult?.length !== 0 && tTestFaLegends?.length === 2 && (
                                        <ComparisonLegend
                                            legends={tTestFaLegends}
                                            moduleName={moduleName}
                                        />
                                    )}
                                </span>
                            </div>
                        )}
                    </td>
                </tr>
            </tbody>
        );
    };

    const getAttributeRows = (attributesArr, rowBackendVariable, macroCategory) => {
        const _rows = attributesArr?.map((ele) => {
            const recallArr = tTestResult?.find(item => item.backendVariable === rowBackendVariable)?.attributes;
            const recallObj = recallArr?.find(item => item.attribute === ele) || {};
            const _tds = draggableColumns?.map((datum, index) => {
                const _score = datum?.scores?.filter((item) => item.title === rowBackendVariable);
                const productCodeTitle = datum.title;
                const productCodeCoreDataId = datum.coreDataId;
                const className = getProductColumnClassName(productCodeTitle, productCodeCoreDataId, productColumnVisibility);
                const _attribute = _score?.[0]?.attribute_values?.find((obj) => obj.attribute_value === ele);
                let productScore = "NA";
                if (_attribute) {
                    productScore = isPercentage ? getCustomRound(Number(_attribute?.percentage)) + "%" : _attribute?.count;
                }
                // console.log("rowBackendVariable", rowBackendVariable);
                // const recallArr = tTestResult?.find((item) => item.backendVariable === rowBackendVariable)?.attributes;
                // const recallObj = recallArr?.find((item) => item.attribute === ele) || {};
                let colorObj = {};
                if (Array.isArray(recallObj?.colors)) {
                    colorObj = recallObj?.colors?.find((item) => item.productCode === productCodeTitle);
                } else if (recallObj?.colors?.productCode === productCodeTitle) {
                    colorObj = recallObj?.colors;
                }
                // if (recallObj) {
                //     if (Object.keys(recallObj).includes("backendVariables")) {
                //         recallTest = recallObj?.backendVariables;
                //         if (recallTest) {
                //             const faBVObj = recallTest?.find((obj) => obj.backendVariable === rowBackendVariable) || {};
                //             colorObj = faBVObj?.colors?.find(item => item.attribute === ele);
                //         }
                //     } else {
                //         recallTest = recallObj?.test_result;
                //         if (recallTest) {
                //             const faBVObj = recallTest?.find((obj) => obj.backendVariable === rowBackendVariable) || {};
                //             colorObj = faBVObj?.colors?.find(item => item.productCode === ele);
                //         }
                //     }
                // }

                const key = `key-${index}`;
                return (
                    <TableCellWithOuterSeparator
                        key={key}
                        value={targetColumnIndex === index && hasActuallyMoved ? "" : productScore}
                        cellType="td"
                        testLabel={colorObj?.["label"] ?? null}
                        mainProps={{
                            className: className,
                        }}
                        styles={{
                            main: {
                                backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "#fff",
                                border: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                                outline: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                            },
                            wrapper: {},
                            value: {
                                justifyContent: "center",
                                background: colorObj?.["common"] ?? "#fff",
                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                borderRadius: "5px",
                                padding: "5px",
                            },
                        }}
                        showSeperator={true}
                    />
                );
            });

            const secondaryBV = `${rowBackendVariable}_${ele}`;
            const hasSecondaryData = checkSecondaryData(secondaryBV);
            const secondaryAttributeArr = getSecondaryAttributes(secondaryBV);

            let secondaryRows = "";
            if (macroCategory === "Primary Fragrances Nodes & Fragrance Descriptors" || macroCategory === "Descriptors") {
                secondaryRows = getSecondaryRows(secondaryAttributeArr, secondaryBV);
            }

            const _row = (
                <>
                    <tr>
                        {(macroCategory === "Primary Fragrances Nodes & Fragrance Descriptors" || macroCategory === "Descriptors") ? (
                            <>
                                <TableCellWithInnerSeparator
                                    value={"Primary Fragrances Nodes"}
                                    cellType="td"
                                    testLabel=""
                                    mainProps={{
                                        colSpan: 1,
                                        align: "center",
                                    }}
                                    styles={{
                                        main: {
                                            left: 0,
                                            position: "sticky",
                                            fontWeight: 500, // Bold only for single study
                                            zIndex: 2,
                                            minWidth: 280,
                                        },
                                        wrapper: {},
                                        value: {
                                            background: "#fff",
                                            whiteSpace: "nowrap",
                                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                            borderRadius: "5px",
                                            padding: "5px",
                                        },
                                    }}
                                />
                                <TableCellWithOuterSeparator
                                    value={
                                        <>
                                            {ele}
                                            {hasSecondaryData && (
                                                <IconButton
                                                    onClick={() => handleSecondaryShow(secondaryBV)}
                                                    style={{
                                                        position: "absolute",
                                                        right: 0,
                                                    }}
                                                >
                                                    {openRows[secondaryBV] ? <KeyboardDoubleArrowUpIcon /> : <KeyboardDoubleArrowDownIcon />}
                                                </IconButton>
                                            )}
                                        </>
                                    }
                                    cellType="td"
                                    testLabel=""
                                    mainProps={{
                                        colSpan: 1,
                                        align: "center",
                                    }}
                                    styles={{
                                        main: {
                                            left: 280,
                                            position: "sticky",
                                            fontWeight: 500, // Bold only for single study
                                            zIndex: 2,
                                        },
                                        wrapper: {},
                                        value: {
                                            background: "#fff",
                                            whiteSpace: "nowrap",
                                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                            borderRadius: "5px",
                                            padding: "5px",
                                        },
                                    }}
                                />
                            </>
                        ) : (
                            <TableCellWithInnerSeparator
                                value={ele}
                                cellType="td"
                                testLabel=""
                                mainProps={{
                                    colSpan: 2,
                                    align: "center",
                                }}
                                styles={{
                                    main: {
                                        left: 0,
                                        position: "sticky",
                                        fontWeight: 500, // Bold only for single study
                                        zIndex: 2,
                                    },
                                    wrapper: {},
                                    value: {
                                        background: "#fff",
                                        whiteSpace: "nowrap",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                            />
                        )}
                        {significanceToggle && (<TableCellWithOuterSeparator
                            value={recallObj?.significance_pvalue || ""}
                            cellType="td"
                            testLabel=""
                            styles={{
                                main: {},
                                wrapper: {},
                                value: {
                                    justifyContent: "center",
                                    background: recallObj?.significance_pvalue ? "#fff" : "#eee",
                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                    borderRadius: "5px",
                                    padding: "5px",
                                },
                            }}
                        />)}
                        {_tds}
                    </tr>
                    {openRows[secondaryBV] && secondaryRows}
                </>
            );

            return _row;
        });

        return _rows;
    };

    const checkSecondaryData = (backendVariable) => {
        const hasData = productsSecondaryData?.some((item) => item.scores.some((score) => score.title === backendVariable && Array.isArray(score?.attribute_values) && score?.attribute_values.length > 0));

        return hasData;
    };

    const handleSecondaryShow = (secondaryBackendVariable) => {
        setOpenRows((prev) => ({
            ...prev,
            [secondaryBackendVariable]: !prev[secondaryBackendVariable],
        }));
        let tempArr = [...openParentList];
        if (tempArr.includes(secondaryBackendVariable)) {
            tempArr = openParentList.filter(ele => ele !== secondaryBackendVariable);
        } else {
            tempArr.push(secondaryBackendVariable)
        }
        dispatch(loadFragranceAssociationOpenParentListState(tempArr));
    };

    const getSecondaryAttributes = (secondaryBackendVariable) => {
        let secondaryAttributes = [];
        draggableColumns?.forEach((datum) => {
            const _scores = datum?.scores?.find((ele) => ele?.title === secondaryBackendVariable);
            if (_scores) {
                _scores?.attribute_values?.forEach((ele) => {
                    if (!secondaryAttributes.includes(ele?.attribute_value)) {
                        secondaryAttributes.push(ele?.attribute_value);
                    }
                });
            }
        });
        const sortedSecondaryAttributes = secondaryAttributes.sort((a, b) => a.localeCompare(b));

        return sortedSecondaryAttributes;
    };

    const getSecondaryRows = (secondaryAttributes, secondaryBackendVariable) => {
        const _rows = secondaryAttributes.map((ele, i) => {
            const recallArr = tTestResult?.find(item => item.backendVariable === secondaryBackendVariable)?.attributes;
            const recallObj = recallArr?.find(item => item.attribute === ele) || {};
            const _tds = draggableColumns?.map((datum, index) => {
                const productCodeTitle = datum.title;
                const productCodeCoreDataId = datum.coreDataId;
                const className = getProductColumnClassName(productCodeTitle, productCodeCoreDataId, productColumnVisibility);
                const attribute = datum?.scores?.find((item) => item?.title === secondaryBackendVariable);
                const _score = attribute?.attribute_values?.find((item) => item?.attribute_value === ele);
                let productScore = "NA";
                if (_score) {
                    productScore = isPercentage ? getCustomRound(Number(_score?.percentage)) + "%" : _score?.count;
                }
                const key = `secondaryKey-${index}`;
                // ttestresult integration
                // const recallArr = tTestResult?.find((item) => item.backendVariable === secondaryBackendVariable)?.attributes;
                // const recallObj = recallArr?.find((item) => item.attribute === ele) || {};
                let colorObj = {};
                if (Array.isArray(recallObj?.colors)) {
                    colorObj = recallObj?.colors?.find((item) => item.productCode === productCodeTitle);
                } else if (recallObj?.colors?.productCode === productCodeTitle) {
                    colorObj = recallObj?.colors;
                }

                return (
                    <TableCellWithOuterSeparator
                        key={key}
                        value={targetColumnIndex === index && hasActuallyMoved ? "" : productScore}
                        cellType="td"
                        testLabel={colorObj?.["label"] ?? null}
                        mainProps={
                            {
                                className: className,
                            }
                        }
                        styles={{
                            main: {
                                backgroundColor: targetColumnIndex === index && hasActuallyMoved ? "#d8eeff" : "#fff",
                                border: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                                outline: targetColumnIndex === index && hasActuallyMoved ? "none" : "",
                            },
                            wrapper: {},
                            value: {
                                justifyContent: "center",
                                background: colorObj?.["common"] ?? "#fff",
                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                borderRadius: "5px",
                                padding: "5px",
                            },
                        }}
                        showSeperator={true}
                    />
                );
            });
            const rowKey = "secondaryRowKey-" + i;

            return (
                <tr key={rowKey}>
                    {i === 0 ? (
                        <>
                            <TableCellWithInnerSeparator
                                key={`secondaryRowKeyFirst-${i}`}
                                value={"Fragrance Descriptors"}
                                cellType="td"
                                testLabel=""
                                mainProps={{
                                    rowSpan: secondaryAttributes.length,
                                    align: "center",
                                }}
                                styles={{
                                    main: {
                                        left: 0,
                                        position: "sticky",
                                        fontWeight: 500, // Bold only for single study
                                        zIndex: 2,
                                        minWidth: 280,
                                    },
                                    wrapper: {},
                                    value: {
                                        background: "#fff",
                                        whiteSpace: "nowrap",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                            />
                            <TableCellWithOuterSeparator
                                key={`secondaryRowKeySecond-${i}`}
                                value={ele}
                                cellType="td"
                                testLabel=""
                                mainProps={{
                                    colSpan: 1,
                                    align: "center",
                                }}
                                styles={{
                                    main: {
                                        left: 280,
                                        position: "sticky",
                                        fontWeight: 500, // Bold only for single study
                                        zIndex: 2,
                                    },
                                    wrapper: {},
                                    value: {
                                        background: "#fff",
                                        whiteSpace: "nowrap",
                                        boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                        borderRadius: "5px",
                                        padding: "5px",
                                    },
                                }}
                            />
                        </>
                    ) : (
                        <TableCellWithOuterSeparator
                            key={`secondaryRowKeySecond-${i}`}
                            value={ele}
                            cellType="td"
                            testLabel=""
                            mainProps={{
                                colSpan: 1,
                                align: "center",
                            }}
                            styles={{
                                main: {
                                    left: 280,
                                    position: "sticky",
                                    fontWeight: 500, // Bold only for single study
                                    zIndex: 2,
                                },
                                wrapper: {},
                                value: {
                                    background: "#fff",
                                    whiteSpace: "nowrap",
                                    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                    borderRadius: "5px",
                                    padding: "5px",
                                },
                            }}
                        />
                    )}
                    {significanceToggle && (<TableCellWithOuterSeparator
                        value={recallObj?.significance_pvalue || ""}
                        cellType="td"
                        testLabel=""
                        styles={{
                            main: {},
                            wrapper: {},
                            value: {
                                justifyContent: "center",
                                background: recallObj?.significance_pvalue ? "#fff" : "#eee",
                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                borderRadius: "5px",
                                padding: "5px",
                            },
                        }}
                    />)}
                    {_tds}
                </tr>
            );
        });

        return _rows;
    };

    // column drag and drop logic
    const handleColumnDragStart = (e, index) => {
        e.dataTransfer.setData("columnIndex", index);
        // Create an invisible image to replace the default drag image
        const img = new Image();
        img.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP88xIAAX8B5sR8D6cAAAAASUVORK5CYII=";
        e.dataTransfer.setDragImage(img, 0, 0);
        setDraggedColumnIndex(index);
        const headerRect = e.target.getBoundingClientRect();
        setMousePosition({
            x: e.clientX - dragOffset.x,
            y: e.clientY - dragOffset.y,
        });

        setDragOffset({
            x: e.clientX - headerRect.left,
            y: e.clientY - headerRect.top,
        });

        setDraggedColumnDiamension({
            width: headerRect.width,
            height: headerRect.height,
        });
        setIsDragging(true);
        initialMousePos.current = { x: e.clientX, y: e.clientY };
        setHasActuallyMoved(false);
    };

    const handleColumnDrop = (index) => {
        const updatedColumns = [...draggableColumns];
        const [draggedColumn] = updatedColumns.splice(draggedColumnIndex, 1);
        updatedColumns.splice(index, 0, draggedColumn);

        setDraggableColumns(updatedColumns);
        setDraggedColumnIndex(null);
        setIsDragging(false);

        const _updateArray = updatedColumns.map((ele) => {
            return {
                productCode: ele.title,
                coreDataId: ele.coreDataId,
                isCompetitor: ele.isCompetitorProduct,
            };
        });
        dispatch(loadProductOrderState([..._updateArray]));
        setHasActuallyMoved(false);
        setTargetColumnIndex(null);
        initialMousePos.current = null;
        setDraggedColumnDiamension({
            width: null,
            height: null,
        });
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        if (!isDragging) return;

        if (!hasActuallyMoved && initialMousePos.current) {
            const dx = Math.abs(e.clientX - initialMousePos.current.x);
            const dy = Math.abs(e.clientY - initialMousePos.current.y);
            if (dx > 5 || dy > 5) {
                setHasActuallyMoved(true);
            }
        }

        setMousePosition({
            x: e.clientX - dragOffset.x,
            y: e.clientY - dragOffset.y,
        });

        if (!hasActuallyMoved) return;

        const headers = Array.from(tableRef.current.querySelectorAll("th")).filter((header) => header.className.includes("checked--"));
        const draggedRect = draggedElementRef.current?.getBoundingClientRect();

        if (!draggedRect) return;

        const closestHeader = headers.reduce((closest, header, index) => {
            if (index === draggedColumnIndex) return closest;

            const rect = header.getBoundingClientRect();
            const center = rect.left + rect.width / 2;
            const distance = Math.abs(e.clientX - center);

            if (!closest || distance < closest.distance) {
                return { index, distance };
            }
            return closest;
        }, null);
        if (closestHeader) {
            if (draggedRect.left + draggedRect.width / 2 < headers[closestHeader.index].getBoundingClientRect().left + headers[closestHeader.index].getBoundingClientRect().width / 2) {
                if (hasActuallyMoved) {
                    setTargetColumnIndex(closestHeader.index);
                }
            }
        }
    };

    const clearAllDragVars = () => {
        setDraggedColumnIndex(null);
        setIsDragging(false);
        setHasActuallyMoved(false);
        setTargetColumnIndex(null);
        initialMousePos.current = null;
        setDraggedColumnDiamension({
            width: null,
            height: null,
        });
    };

    const handleProductClick = (e, info) => {
        setProductDetailsDialogueOpen(true);
        setSelectedProductInfo(info);
    };

    return (
        <div>
            <ColumnVisibility
                productsSecondaryData={draggableColumns}
                pageName={moduleName}
            />
            <div
                className="table-responsive"
                style={{
                    width: "100%",
                    position: "relative",
                    minHeight: "584px",
                    top: -25,
                }}
            >
                <table
                    ref={tableRef}
                    onMouseLeave={clearAllDragVars}
                    className="table text-sm analysis-table"
                    style={{
                        background: "transparent",
                        borderCollapse: "separate",
                        borderSpacing: "0",
                    }}
                >
                    <thead>{returnTableHeader()}</thead>
                    <tbody ref={tbodyRef}>
                        {returnConsumerFilterRow()}
                        {isITMDataShown && returnItmRecallLabelRow()}
                        {box && returnBoxAnalysisLabelRow()}
                    </tbody>
                    {overallFragranceToggle && returnAnalysisScoresRow()}
                    {returnOverallAssociationRows()}
                </table>
            </div>
            {isDragging && draggedColumnIndex !== null && hasActuallyMoved && (
                <DragRenderTable
                    dragSettings={{
                        draggableColumns: draggableColumns,
                        draggedColumnIndex: draggedColumnIndex,
                        mousePosition: mousePosition,
                        draggedColumnDiamension: draggedColumnDiamension,
                        // tableColSpan: tableColSpan,
                        tableHeadSpan: tableHeadSpan,
                        draggedElementRef: draggedElementRef,
                    }}
                    analysisView={{
                        box: box,
                        isITMDataShown: isITMDataShown,
                        moduleName: moduleName,
                        analysisTypeValue: analysisTypeValue,
                        boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                    }}
                    productData={{
                        noOfProducts: noOfProducts,
                    }}
                    tableData={{
                        tableDataMapping: tableDataMapping,
                        isConsumerFilterLoadingStoreData: isConsumerFilterLoadingStoreData,
                        removedKpiStoreState: removedKpiStoreState,
                        dataViewKey: dataViewKey,
                        tTestResult: tTestResult,
                    }}
                />
            )}
            {!["overall", "claims", "fragranceMetrics"].includes(moduleName) && (
                <SkewTabs
                    tableData={{
                        productsSecondaryDataState: draggableColumns,
                    }}
                    settings={{
                        activeTab: activeTab,
                        setActiveTab: setActiveTab,
                    }}
                    analysisView={{
                        moduleName: moduleName,
                        mappings: skewTabsOverallFragranceMapping,
                        analysisTypeValue: analysisTypeValue,
                        boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                    }}
                />
            )}
            <AnalysisTableBottomLabel
                actionStandard={{
                    actionStandardKpis: actionStandardKpis,
                    actionStandardData: actionStandardData,
                    showActionStandardsInfo: true,
                }}
                tTest={{
                    tTestLegends: tTestLegends,
                    isFisher: isFisher,
                    tTestResult: tTestResult,
                    testLabel: testLabel,
                }}
                analysisView={{
                    moduleName: moduleName,
                }}
            />
            {productDetailsDialogueOpen && (
                <ProductInfo
                    settings={{
                        productDetailsDialogueOpen: productDetailsDialogueOpen,
                        setProductDetailsDialogueOpen: setProductDetailsDialogueOpen,
                    }}
                    info={selectedProductInfo}
                    productsSecondaryData={productsSecondaryData}
                />
            )}
        </div>
    );
}

AnalysisTableFragranceAssociation.propTypes = {
    productsSecondaryData: PropTypes.array,
    tTest: PropTypes.object,
    handleFilterSubmit: PropTypes.func,
    analysisLevelData: PropTypes.object,
    settings: PropTypes.object,
    onRenderComplete: PropTypes.func,
};
export default AnalysisTableFragranceAssociation;
